/* ======= 최소 구현: freeLimit만 세팅 ======= */
 
/* (선택) 간단 캐시 */
function cacheGet(k){try{const x=localStorage.getItem(k);if(!x)return null;const {v,exp}=JSON.parse(x);return Date.now()>exp?null:v;}catch{return null}}
function cacheSet(k,v,ttl=3600_000){try{localStorage.setItem(k,JSON.stringify({v,exp:Date.now()+ttl}))}catch{}}

/* GraphQL 엔드포인트 & 쿼리 (필요 필드만) */
const DP_ENDPOINT = 'https://eyotfl3wwh.execute-api.ap-northeast-2.amazonaws.com/graphql';
const DP_QUERY = `query dp(
  $methodDefinitionsPageSize:Int=10,
  $locationGroupZonesPageSize:Int=50,
  $methodDefinitionsCursor:String,
  $locationGroupZonesCursor:String
){
  deliveryProfiles(first: 10) {
    nodes {
      profileLocationGroups {
        locationGroupZones(first:$locationGroupZonesPageSize, after:$locationGroupZonesCursor){
          edges {
            node {
              methodDefinitions(first:$methodDefinitionsPageSize, after:$methodDefinitionsCursor){
                edges {
                  node {
                    name
                    methodConditions {
                      operator
                      conditionCriteria {
                        ... on MoneyV2 { amount currencyCode }
                      }
                    }
                    rateProvider {
                      ... on DeliveryRateDefinition {
                        price { amount currencyCode }
                      }
                    }
                  }
                }
              }
              zone {
                countries { code { countryCode } }
              }
            }
          }
        }
      }
    }
  }
}`;

/* 1) 배송 프로필 로드 */
async function fetchDeliveryProfiles(){
  const cacheKey = 'dp_cache_v1';
  const cached = cacheGet(cacheKey);
  if (cached) return cached;

  const res = await fetch(DP_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/graphql' },
    body: DP_QUERY
  });
  const json = await res.json();
  const nodes = json?.data?.deliveryProfiles?.nodes || [];
  cacheSet(cacheKey, nodes, 10 * 60 * 1000); // 10분 캐시
  return nodes;
}

/* 2) 국가에 해당하는 옵션만 뽑아서 {minAmt,maxAmt,amt,currency,name} 형태로 반환 */
function extractOptionsForCountry(nodes, countryCode){
  const list = [];
  const cc = (countryCode || '').toUpperCase();
  if (!nodes?.length || !cc) return list;

  const groups = nodes[0]?.profileLocationGroups || [];
  const zones = groups[0]?.locationGroupZones?.edges || [];
  for (const z of zones){
    const node = z?.node;
    const countries = node?.zone?.countries || [];
    const match = countries.some(c => c?.code?.countryCode === cc);
    if (!match) continue;

    const methods = node?.methodDefinitions?.edges || [];
    for (const m of methods){
      const md = m?.node;
      const price = md?.rateProvider?.price;
      if (!price || typeof price.amount === 'undefined') continue;

      const opt = {
        name: md?.name || '',
        amt: Number(price.amount),
        currency: String(price.currencyCode || '')
      };

      // 조건에서 금액 하한/상한 추출
      let minAmt = 0, maxAmt = 0;
      for (const cond of (md?.methodConditions || [])){
        if (!cond?.conditionCriteria?.amount) continue;
        const val = Number(cond.conditionCriteria.amount);
        if (cond.operator === 'GREATER_THAN_OR_EQUAL_TO') minAmt = val;
        if (cond.operator === 'LESS_THAN_OR_EQUAL_TO')   maxAmt = val;
      }
      opt.minAmt = minAmt;
      opt.maxAmt = maxAmt;
      list.push(opt);
    }
  }
  return list;
}

/* 3) freeLimit 계산: 배송비가 0(무료)인 옵션들의 minAmt 중 최소값 */
function computeFreeLimit(options){
  const freeMins = options
    .filter(o => Number(o.amt) === 0)
    .map(o => Number(o.minAmt))
    .filter(v => Number.isFinite(v) && v >= 0);
  if (!freeMins.length) return null;
  return Math.min(...freeMins);
}

/* 4) 초기화: country_code(hidden) 값으로 현재 국가 판단 → freeLimit 주입 */
async function initFreeLimit(){
  try{
    const countryInput = document.getElementById('country_code');
    const countryCode = countryInput?.value;
    if (!countryCode){
      console.warn('country_code input not found or empty');
      return;
    }

    const nodes   = await fetchDeliveryProfiles();
    const options = extractOptionsForCountry(nodes, countryCode);
    const freeLimit = computeFreeLimit(options);

    if (freeLimit != null){
      document.body.setAttribute('data-freelimit', String(freeLimit));
      // 통화 아이콘/코드가 필요하면 여기서도 세팅 가능:
      // document.body.setAttribute('data-currency', options[0]?.currency || '');
      // document.body.setAttribute('data-crcicon', document.getElementById('crc_symbol')?.value || '');
    } else {
      // 무료배송 없음 → 속성 제거(선택)
      document.body.removeAttribute('data-freelimit');
    }
  } catch (err){
    console.error('initFreeLimit error:', err);
  }
}

/* 5) DOM 로드 시 실행 */
document.addEventListener('DOMContentLoaded', initFreeLimit);


/*
(function(){
  function paint(root){
    var b=document.body;
    var limit=b.getAttribute('data-freelimit');
    var iso=b.getAttribute('data-crcicon');
    if(!limit||!iso)return;
    var nodes=(root instanceof Element?root:document).querySelectorAll('.js-free-shipping-text');
    nodes.forEach(function(p){
      var lead=p.getAttribute('data-fstext')||'Free shipping above';
      p.textContent=lead+' '+iso+limit;
    });
  }
  document.addEventListener('DOMContentLoaded',function(){paint(document);});
  new MutationObserver(function(m){
    m.forEach(function(x){
      x.addedNodes.forEach(function(n){
        if(n.nodeType!==1)return;
        if(n.matches && n.matches('.js-free-shipping-text,.cart-drawer,.cart-drawer__information-bar-content')) paint(n);
        else if(n.querySelector && n.querySelector('.js-free-shipping-text')) paint(n);
      });
    });
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
*/
(function(){
  var raf, pending = false;

  function getSymbol() {
    var b = document.body;
    var icon = b.getAttribute('data-crcicon');
    if (icon && icon.trim()) return icon;
    var iso = b.getAttribute('data-crciso') || b.getAttribute('data-currency') || '';
    if (!iso) return '';
    try {
      var parts = new Intl.NumberFormat(undefined, {style:'currency', currency: iso}).formatToParts(0);
      var cur = parts.find(function(p){ return p.type === 'currency'; });
      return cur ? cur.value : '';
    } catch(e) { return ''; }
  }

  function getLimit() {
    var b = document.body;
    return b.getAttribute('data-freelimit') || b.getAttribute('data-freelimit-major') || '';
  }

  function paint(root){
    var limit = getLimit();
    var sym = getSymbol();
    if(!limit || !sym) return;
    var scope = (root instanceof Element ? root : document);
    var nodes = scope.querySelectorAll('.js-free-shipping-text');
    for (var i=0;i<nodes.length;i++){
      var p = nodes[i];
      var lead = p.getAttribute('data-fstext') || 'Free shipping above';
      p.textContent = lead + ' ' + sym + limit;
    }
  }

  function schedulePaint(target){
    if (pending) return;
    pending = true;
    raf && cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function(){
      pending = false;
      paint(target || document);
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    schedulePaint(document);
  });

  window.addEventListener('pageshow', function(){
    schedulePaint(document);
  }, { once:false });

  var mo = new MutationObserver(function(muts){
    var repaint = false;
    for (var i=0;i<muts.length;i++){
      var m = muts[i];

      if (m.type === 'attributes' && m.target === document.body) {
        if (m.attributeName === 'data-freelimit' || m.attributeName === 'data-freelimit-major' || m.attributeName === 'data-crcicon' || m.attributeName === 'data-crciso' || m.attributeName === 'data-currency') {
          repaint = true;
        }
      }

      if (m.type === 'childList') {
        if (m.addedNodes && m.addedNodes.length) {
          for (var j=0;j<m.addedNodes.length;j++){
            var n = m.addedNodes[j];
            if (n.nodeType !== 1) continue;
            if (n.matches && n.matches('.js-free-shipping-text,.cart-drawer,.drawer,[data-drawer],.cart-drawer__information-bar-content,.shopify-section,[data-section-id]')) {
              repaint = true;
              break;
            }
            if (n.querySelector && n.querySelector('.js-free-shipping-text')) {
              repaint = true;
              break;
            }
          }
        }
      }
      if (repaint) break;
    }
    if (repaint) schedulePaint(document);
  });

  mo.observe(document.documentElement, { childList:true, subtree:true });
  mo.observe(document.body, { attributes:true, attributeFilter:['data-freelimit','data-freelimit-major','data-crcicon','data-crciso','data-currency'] });

  document.addEventListener('shopify:section:load', function(e){
    schedulePaint(e.target || document);
  });

  document.addEventListener('cart:refresh', function(e){
    schedulePaint(e.target || document);
  });

  setTimeout(function(){ schedulePaint(document); }, 800);
})();